import React from 'react'
import Draggable from 'react-draggable'
import type { ModalProps } from 'react-bootstrap'
import { ModalDialog } from 'react-bootstrap'

export const DraggableModal = (props: ModalProps) => {
  const nodeRef = React.useRef<HTMLDivElement>(null)
  return (
    <Draggable handle=".drag-handle" nodeRef={nodeRef}>
      <ModalDialog {...props} ref={nodeRef} />
    </Draggable>
  )
}
